import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getTemplates } from '../../utils/templates';
import { ProjectTemplate } from '../../types';

// Query keys
export const templateKeys = {
  all: ['templates'] as const,
  lists: () => [...templateKeys.all, 'list'] as const,
  list: (projectId?: string, isLoggedIn?: boolean) => 
    [...templateKeys.lists(), projectId, isLoggedIn] as const,
};

/**
 * Hook to fetch templates for a project
 * Templates can be fetched even without a projectId (for unauthenticated users)
 */
export function useTemplates(
  projectId?: string,
  isLoggedIn?: boolean,
  options?: Omit<UseQueryOptions<ProjectTemplate[], Error>, 'queryKey' | 'queryFn'>
) {
  return useQuery<ProjectTemplate[], Error>({
    queryKey: templateKeys.list(projectId, isLoggedIn),
    queryFn: async () => {
      return await getTemplates(!!isLoggedIn, projectId);
    },
    staleTime: 30 * 1000, // 30 seconds
    gcTime: 5 * 60 * 1000, // 5 minutes
    enabled: isLoggedIn !== undefined, // Only wait for auth status, projectId is optional
    ...options,
  });
}
